// Mirrors backend/capabilities.py: two tenant access levels (Member, Tenant Admin)
// plus the platform owner. What a Member can do beyond asking questions comes from
// ticks the Tenant Admin sets in their permissions.

export const CAPABILITIES = [
  { key: 'can_manage_teams', label: 'Manage teams and users', description: 'Create and edit teams, departments and the Org Chart, and add people to teams.' },
  { key: 'can_manage_knowledge', label: 'Manage all knowledge', description: 'Upload, edit and refresh any knowledge. Deleting is a separate tick.' },
  { key: 'can_assign_escalations', label: 'Assign escalations', description: 'Assign and reassign escalated questions to the right person.' },
];

export const isPlatform = (user) => Boolean(user) && (user.role === 'master_admin' || user.is_master_admin === true);

// top_manager is read as Tenant Admin only until the switch-over script has run.
export const isTenantAdmin = (user) => Boolean(user) && ['admin', 'top_manager'].includes(user.role) && user.is_master_admin !== true;

export const isAdminOrPlatform = (user) => isTenantAdmin(user) || isPlatform(user);

export const can = (user, capability) => {
  if (!user) return false;
  if (isAdminOrPlatform(user)) return true;
  if (user.role === 'team_manager') {
    // Old Managers who were Source Leaders were limited to their teams' knowledge.
    return capability !== 'can_manage_knowledge' || !user.is_source_lead;
  }
  return user.permissions?.[capability] === true;
};

export const canAny = (user) => CAPABILITIES.some(({ key }) => can(user, key));
